// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageBox/index.less"],"names":[],"mappings":"AAAA;EAAK,WAAA;AAEL","sourcesContent":["body{margin:0px;}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
